import { observer } from 'mobx-react-lite'
import type { BudgetRow } from 'app/services/budget'
import { PlusIcon } from '@heroicons/react/20/solid'
import { ColumnDef } from '@tanstack/react-table'
import SimpleTable from 'app/components/table/SimpleTable'

export type BudgetListComponentProps = {
  filteredRows: BudgetRow[]
  columns: ColumnDef<BudgetRow>[]
  onAddNew?: () => void
}

export const BudgetListComponent = observer(function BudgetListComponent({
  filteredRows,
  columns,
  onAddNew,
}: BudgetListComponentProps) {
  return (
    <SimpleTable
      data={filteredRows}
      columns={columns}
      extraSlot={
        <button className="btn btn-primary btn-sm ml-4 flex items-center gap-2" onClick={onAddNew}>
          <PlusIcon className="h-4 w-4" />
          Add New Budget
        </button>
      }
      showColumnOrdering
    />
  )
})
